import {
  IntegrationCredential,
  IntegrationCredentialSecret,
  IntegrationCredentialTestResult,
} from '@rossum/api-client/integrationCredentials';

export type Credential = IntegrationCredential;
export type CredentialSecret = IntegrationCredentialSecret;

export type CredentialTestResult = IntegrationCredentialTestResult;

export const credentialTypes = ['coupa_sand_oauth2'] as const;

export type CredentialType = (typeof credentialTypes)[number];

export const isKnownCredentialType = (value: string): value is CredentialType =>
  credentialTypes.some(type => type === value);
